import ResultsServiceModel from '@/models/ResultsServiceModel'

export default class RecommendationModel extends ResultsServiceModel {
  modelName () {
    return 'recommendations'
  }

  defaults () {
    return {
      id: null,
      result_id: null,
      sample_id: null,
      override: null,
      override_customer_id: null,
      crop: null,
      yield: null,
      comment: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  mutations () {
    return {
      id: val => this.nullStringMutator(val),
      result_id: val => this.nullStringMutator(val),
      sample_id: val => (val ? this.nullStringMutator(val) : undefined),
      override: val => this.nullStringMutator(val),
      override_customer_id: val => this.nullStringMutator(val),
      crop: val => this.nullStringMutator(val),
      yield: val => this.nullStringMutator(val),
      comment: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val),
    }
  }
}
